<!-- ImageAuth.vue -->
<template>
  <template v-if="!imageDataUrl && !hasError">
    <div class="placeholder"></div>
  </template>

  <template v-else-if="hasError">
    <img :src="fallbackImage" />
  </template>

  <template v-else>
    <img :src="imageDataUrl" />
  </template>
</template>

<script>
import axiosInstance from "@/services/AxiosTokenInstance";

export default {
  name: "ImageAuth",
  props: {
    imageId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      imageDataUrl: null,
      hasError: false,
      fallbackImage: require("@/assets/img/icons/image-placeholder.svg"),
    };
  },
  methods: {
    getImage(newImageId) {
      // Reset error state when loading new image
      this.hasError = false;
      this.imageDataUrl = null;

      axiosInstance
        .get(`media_objects/${newImageId}/contents`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const contentType = response.headers["content-type"] || "image/png";

          this.imageDataUrl = `data:${contentType};base64,${this.arrayBufferToBase64(
            response.data
          )}`;
          this.hasError = false;
        })
        .catch((error) => {
          console.error("Error fetching image:", error);
          this.hasError = true;
        });
    },

    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;

      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      return btoa(binary);
    },
  },
  watch: {
    imageId: function (newImageId) {
      this.getImage(newImageId);
    },
  },
  mounted() {
    if (this.imageId) {
      this.getImage(this.imageId);
    }
  },
};
</script>

<style scoped>
.placeholder {
  width: 100%;
  height: 100%;
  background-color: #ccc;
  filter: blur(20px);
  transition: filter 0.5s ease;
}
</style>
